module.exports = __webpack_public_path__ + "img/b_Sink_left.b9709471.jpeg";